module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFUAAABVAQMAAAACOzoZAAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAAB5JREFUKM9jAIMHYHKUPczZ/+HgBy72oHDnKJsubABTgWiLkKceQQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-plus.png
// module id = 69
// module chunks = 168707334958949